module.exports = __webpack_public_path__ + "img/banner.aa3f6b98.jpg";